import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { sendEmailFromDetached } from "./saga/sendEmailFromDetachedSaga";

/**
 * Client Modul für das Nachfordern von Informationen (Modul 11 in MODUL-F)
 */
const modul11InformationenNachfordernModule = (): Module => ({
	id: "modul11InformationenNachfordernModule",
	sagas: () => [sendEmailFromDetached]
});

export default modul11InformationenNachfordernModule;
